export class User {
  constructor(
    public idUsuario: number,
    public usuario: string,
    public password: string,
    public nombre: string,
    public expiration: Date,
    public codigoNivel: string,
    public idGrupo: number,
    public idCliente: number,
    public token?: string,
    public urlAplicacion?: string
  ) {}
}
